import FormTextArea from "component/form/form_textarea";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultClientInfoSelector } from "store/user/(default)/client/default_client.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientNote = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const clientInfo = useSelector(defaultClientInfoSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!clientInfo) return null;
  return (
    <FormTextArea
      name="note"
      rules={[{ required: true, message: "Điền thông tin đầy đủ" }]}
      placeholder="Ghi chú thêm: Thuộc chi nhánh Dịch Vụ Chuyển Âm nào ?"
      rows={4}
    />
  );
};
export default ClientNote;
